"use client";

import { ConfigKey, fetchMultipleConfigs } from "@/service/config";
import { configStore } from "@/store/configStore";
import useSWR from "swr";

/**
 * Hook to fetch multiple configs at once with a single API call
 * More efficient than calling useConfig multiple times
 */
export function useMultipleConfigs() {
  const keys: ConfigKey[] = [
    "tool_status_config",
    "pricing_page_config",
    "banner_config",
  ];

  return useSWR(
    `configs:${keys.join(",")}`,
    async () => fetchMultipleConfigs(keys),
    {
      onSuccess: (data) => {
        // Update all configs in the store
        if (data["tool_status_config"]) {
          configStore.setToolConfig(data["tool_status_config"]);
        }
        if (data["pricing_page_config"]) {
          configStore.setPricingPageConfig(data["pricing_page_config"]);
        }
        if (data["banner_config"]) {
          configStore.setBannerConfig(data["banner_config"]);
        }
      },
      refreshInterval: 60 * 1000,
      revalidateOnFocus: false,
    },
  );
}
